import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import vendingMachineImg from '../assets/vending-machine.png';

const HeroSection = () => {
    const scrollToContact = () => {
        const element = document.querySelector('#contact');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    /*
        const scrollToProducts = () => {
            const element = document.querySelector('#products');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        };*/

    const scrollToHowItWorks = () => {
        const element = document.querySelector('#how-it-works');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50">
            {/* Background Elements */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-20 right-0 w-96 h-96 bg-blue-100/50 rounded-full blur-3xl"></div>
                <div className="absolute bottom-20 left-0 w-80 h-80 bg-slate-100 rounded-full blur-3xl"></div>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-8 lg:py-14">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
                    {/* Content */}
                    <div className="space-y-8 lg:pt-8">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-100 rounded-full " data-aos="fade-up"
                            data-aos-delay="50"        // AOS
                        >

                            <MapPin size={16} className="text-blue-500" />
                            <span className="text-sm font-medium text-blue-700">Based in Costa del Sol</span>
                        </div>

                        <h1
                            className="text-5xl lg:text-6xl xl:text-7xl font-bold text-slate-900 leading-tight"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            Premium Vending.
                            <span className="block text-3xl lg:text-4xl xl:text-5xl font-semibold mt-2">
                                Fully Managed<span className="text-blue-500">.</span>
                            </span>
                        </h1>


                        <p className="text-xl text-slate-600 max-w-lg leading-relaxed" data-aos="fade-up"
                            data-aos-delay="150">
                            Increase guest convenience while creating an additional revenue stream for your venue.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4" data-aos="fade-up"
                            data-aos-delay="200">
                            <button
                                onClick={scrollToContact}
                                className="group px-8 py-4 bg-slate-900 text-white font-semibold rounded-full hover:bg-slate-800 transition-all duration-300 hover:shadow-xl hover:shadow-slate-900/20 flex items-center justify-center gap-2"
                            >
                                Get a Machine
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </button>
                            <button
                                onClick={scrollToHowItWorks}
                                className="px-7 py-4 bg-white text-slate-600 font-semibold rounded-full border border-slate-200 hover:border-slate-300 hover:bg-slate-50 transition-all duration-300"
                            >
                                How It Works
                            </button>
                        </div>

                        {/* Limited rollout note 
                        <p
                            className="text-sm text-slate-500 max-w-lg"
                            data-aos="fade-up"
                            data-aos-delay="225"
                        >
                            We’re onboarding a limited number of venues during our initial rollout to ensure quality and availability.
                        </p>*/}

                        {/* Stats */}
                        <div className="flex gap-12 pt-8 border-t border-slate-200" data-aos="fade-up"
                            data-aos-delay="250">
                            <div>
                                <div className="text-3xl font-bold text-slate-900">0€</div>
                                <div className="text-sm text-slate-500">Venue Investment</div>
                            </div>
                            <div>
                                <div className="text-3xl font-bold text-slate-900">100%</div>
                                <div className="text-sm text-slate-500">Cashless Payments</div>
                            </div>
                            <div>
                                <div className="text-3xl font-bold text-slate-900">18+</div>
                                <div className="text-sm text-slate-500">Age Verified</div>
                            </div>
                        </div>
                    </div>

                    {/* Visual */}
                    <div className="relative lg:pl-10" >
                        <div className="relative">
                            {/* Main Card */}
                            <div className="bg-white rounded-3xl shadow-2xl shadow-slate-200/50 p-8 lg:p-10 border border-slate-100">
                                <div className="relative aspect-[4/5] rounded-2xl bg-gradient-to-br from-white via-slate-50 to-blue-50 flex flex-col items-center justify-center overflow-visible">

                                    {/* Soft glow behind machine */}
                                    <div className="absolute inset-0">
                                        <div className="absolute inset-12 rounded-3xl bg-white/40 blur-2xl" />
                                    </div>

                                    {/* Vending Machine Image */}
                                    <img
                                        src={vendingMachineImg}
                                        alt="here. vape vending machine"
                                        className="relative w-[58%] max-w-[300px] drop-shadow-xl"
                                    />

                                    {/* Brand text under machine */}
                                    <div className="relative mt-8 mb-4 text-center">
                                        <div className="text-3xl font-bold text-slate-900 tracking-tight">
                                            here<span className="text-blue-500">.</span>
                                        </div>
                                        <div className="text-slate-300 text-xs tracking-[0.2em] uppercase">
                                            Vending
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Floating Card */}
                            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl shadow-xl shadow-slate-200/40 p-4 border border-slate-100">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
                                        <svg className="w-5 h-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="font-semibold text-slate-900 leading-tight text-base">Age Verified</div>
                                        <div className="text-sm text-slate-500 leading-tight">ID Scanning Tech</div>
                                    </div>
                                </div>
                            </div>

                            {/* Another Floating Card */}
                            { /*
                            <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-4 border border-slate-100">
                                <div className="flex items-center gap-2">
                                    <div className="flex -space-x-2">
                                        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-bold">M</div>
                                        <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center text-white text-xs font-bold">F</div>
                                    </div>
                                   <span className="text-sm font-medium text-slate-700">Marbella & More</span>
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
